/**
 * Decision D36: after signing in, people land on the page they were opening (a digest's
 * "Open alerts" link, a /jobs/<id> link), not always on /board. Signed out, every URL shows the
 * sign-in page, so the current URL is the destination. Clerk's own query params are dropped, and
 * so are its hash routes ("#/factor-one"); the app's anchors ("#archived") are kept.
 */
export function currentDestination(): string {
  const url = new URL(window.location.href);
  for (const key of [...url.searchParams.keys()]) {
    if (key.startsWith("__clerk")) url.searchParams.delete(key);
  }
  if (url.pathname === "/sso-callback") return "/board";
  const hash = url.hash.startsWith("#/") ? "" : url.hash;
  return url.pathname + url.search + hash;
}

const KEY = "backplan:destination";

/** Google sign-in leaves the app, so the destination waits in session storage until /sso-callback. */
export function rememberDestination(): void {
  try {
    sessionStorage.setItem(KEY, currentDestination());
  } catch {
    // Storage can be blocked; the user then lands on /board.
  }
}

export function takeRememberedDestination(): string {
  try {
    const stored = sessionStorage.getItem(KEY);
    sessionStorage.removeItem(KEY);
    // Only same-site paths, so a stored value can't send anyone to another site.
    if (stored?.startsWith("/") && !stored.startsWith("//")) return stored;
  } catch {
    // Fall through to the default.
  }
  return "/board";
}
